import React, { FC } from "react";

import { Icon, Typography } from "ui-library/atoms";
import { Box, Flexbox } from "ui-library/layouts";

export interface ErrorMessageProps {
    message: string;
    showIcon?: boolean;
}

export const ErrorMessage: FC<ErrorMessageProps> = ({ message, showIcon = false }) => (
    <Flexbox mb={2}>
        {showIcon && (
            <Box mt={0.2} mr={0.5}>
                <Icon className="tooltip" size={16} icon={"alert"} color="red" />
            </Box>
        )}
        <Typography variant="h4" color="red" markDown={message} />
    </Flexbox>
);
